import React from "react";
import { TransactionLocked } from "@common/constants";
import { FiltersTypes } from "@common/types/filters/general";

interface TransactionLockedFilterLabelProps {
    filters: Pick<FiltersTypes, "transactionLocked">;
}

export const TransactionLockedFilterLabel: React.FC<
    TransactionLockedFilterLabelProps
> = ({ filters: { transactionLocked } }) => (
    <>
        {transactionLocked === TransactionLocked.LOCKED ? "Locked" : "Unlocked"}
    </>
);
